import { useSyncTheme } from './hooks/useSyncTheme';

export const SynchronizeTheme = () => {
  useSyncTheme();

  return null;
};
